/**
 * Cómo se NOMBRA un campo y cómo se titula un panel sin título propio.
 *
 * Puro (sin React) para poder testearlo: el catálogo del Explorador (`FIELD_DATA_BY_ID`) viene
 * del mismo endpoint que la pantalla ya carga, e incluye las métricas personalizadas de la
 * agencia, que el catálogo estático del backend no conoce.
 *
 * Dos problemas del QA se resuelven acá:
 *  - UI-06: los selects mostraban la clave interna («Campana») y la tabla el rótulo («Campaña»).
 *  - FE-05 / UI-13: en el portal, un KPI sin título mostraba el placeholder «Métrica destacada»
 *    (o la clave técnica «Meta_Costo_por_grouped_lead» en los informes migrados), así que el
 *    cliente veía dos números grandes sin saber qué eran.
 */
import {PANEL_TYPES} from './informeModel';
import {defaultTitleKey} from './panelLayout';

/** El nombre del catálogo para un id de campo; el id crudo si el catálogo no lo conoce. */
export function fieldLabel(fieldId, fieldsData) {
    if (!fieldId) return '';
    const byId = (fieldsData && fieldsData.FIELD_DATA_BY_ID) || {};
    const field = byId[fieldId];
    return (field && field.name) || fieldId;
}

/** La primera métrica de un panel, si tiene. */
function firstMetric(panel) {
    return (panel && panel.metrics && panel.metrics[0]) || null;
}

/**
 * El título que se muestra cuando el panel no tiene uno propio: el nombre de su métrica cuando
 * el panel es de una sola métrica (destacada, torta), y el rótulo genérico del tipo si no.
 *
 * Un título que sea EXACTAMENTE un id del catálogo también se traduce a su nombre: los informes
 * migrados desde el Explorador viejo se titularon con la clave técnica de la métrica, y el
 * catálogo del navegador —a diferencia del estático del backend, que hizo la migración— sí sabe
 * cómo se llama.
 */
export function panelTitle(panel, fieldsData, t) {
    const raw = (panel && panel.title) || '';
    const byId = (fieldsData && fieldsData.FIELD_DATA_BY_ID) || {};
    if (raw) return byId[raw] ? fieldLabel(raw, fieldsData) : raw;
    // Un bloque de texto sin título no lleva ninguno: el genérico («Panel», «Texto») arriba de
    // un párrafo no le dice nada al cliente.
    if (panel && panel.type === PANEL_TYPES.TEXT) return '';

    const metric = firstMetric(panel);
    const singleMetric = panel && (panel.type === PANEL_TYPES.KPI || panel.type === PANEL_TYPES.PIE);
    if (metric && singleMetric && byId[metric]) return fieldLabel(metric, fieldsData);

    const key = defaultTitleKey(panel ? panel.type : null);
    return t ? t(key) : '';
}
